(function () {
  const style = document.createElement("style");
  style.innerHTML = `
    .wavy {
        animation-name: wavy;
        animation-duration: 1.3s;
        animation-timing-function: ease;
        animation-iteration-count: infinite;
        position: relative;
        top: 0;
        left: 0;
        }
        @keyframes wavy {
        0% {
            top: 0px;
        }
        50% {
            top: -5px;
        }
        100% {
            top: 0px;
        }
        }
    `;
  document.body.appendChild(style);

  document.querySelectorAll(".DynamicTopbar .swiper-slide h1").forEach((el) => {
    wavyText(el);
  });

  document.querySelector(".DynamicTopbar .swiper").swiper.slideNext();
  function wavyText(el) {
    let delay = 200;

    el.innerHTML = el.innerText
      .split("")
      .map((letter) => {
        return `<span>` + letter + `</span>`;
      })
      .join("");

    Array.from(el.children).forEach((span, index) => {
      setTimeout(() => {
        span.classList.add("wavy");
      }, index * 60 + delay);
    });
  }

})();
